<template>
  <div>
    <div class="menu-group flex-column" v-if="menuGroupsData?.length">
      <ul v-for="(menuGroup, index) in menuGroupsData" :key="index">
        <li
          class="menu-item"
          v-for="(item, index) in menuGroup"
          :key="index"
          v-on:click="handleDrawerClick($event, item)"
        >
          <span
            class="hm-icon"
            v-if="item?.menuGroup === 'SideBarPwa_user_links'"
          >
            <i class="fs-18 color-jfl-orange" :class="item?.iconsCSS"></i>
            <!-- <lazy-image :src="item.icon" /> -->
          </span>

          <a
            :href="item?.link_rewrite"
            class="fg-1 fs-14 color-base"
            v-on:click="handleDrawerClick($event, item)"
            >{{ item?.name }}
            <span
              v-if="item?.linkRewrite?.includes('/offer') && getCouponText"
              class="fs-10 fw-700 ptb5 plr10 ml10 border-radius-4 promo-offer-bar-active color-green-offer"
              >{{ getCouponText }}</span
            ><span
              v-if="item?.linkRewrite?.includes('/wallet') && getWalletText"
              class="fs-10 fw-700 ptb5 plr10 ml10 border-radius-4 promo-offer-bar-active color-green-offer"
              >{{ getWalletText }}</span
            ></a
          >
          <i class="hkfi-arrow-line fs-12 color-slaty bold"></i>
        </li>
      </ul>
    </div>
    <shimmer-profile-drawer-modal v-else></shimmer-profile-drawer-modal>

    <div class="fs-14 underlined color-grey-light pl16">
      <span v-if="isLoggedIn" @click="handleLogoutPopup()">Logout </span>
    </div>
    <!-- logout modal popup -->
    <div class="logout-modal">
      <generic-modal
        v-if="showLogoutModal"
        @close="closeAppliedModal('clicked')"
        :borderRadius="'8px'"
        :height="LogoutModalDim.height"
        :width="LogoutModalDim.width"
        :padding="LogoutModalDim.padding"
        :paddingTop="LogoutModalDim.paddingTop"
        :paddingBottom="LogoutModalDim.paddingBottom"
        :class="[
          clientPlatform == 'Web'
            ? 'modal-mask  full-screen-popup  lg-screen-centered'
            : 'd-flex justify-content-center align-items-center plr40',
        ]"
      >
        <template v-slot:header></template>
        <template v-slot:body>
          <div class="tc pt25" :class="{ pd20: clientPlatform == 'Web' }">
            <h1 class="fs-16 bold">Logout?</h1>
            <div class="fs-14 plr20 pt8">
              You'll have to login again to place the order.
            </div>
            <div class="logout-line"></div>
            <div class="d-flex justify-content-evenly align-items-center">
              <span
                class="fs-14 color-slaty hand bold"
                @click="handleLogoutPopup()"
              >
                Cancel
              </span>
              <span class="vl"></span>
              <span
                class="fs-14 color-tertiary hand bold"
                @click="handleLogoutCTA()"
              >
                Logout
              </span>
            </div>
          </div>
        </template>
        <template v-slot:footer></template>
      </generic-modal>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide, Pagination } from "vue3-carousel";
import LocalStorageFunc from "../helpers/localStorageFunc";
import "vue3-carousel/dist/carousel.css";
import GenericModal from "./GenericModal.vue";
import Utility from "../helpers/utility";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import { OrderHistoryPages } from "../helpers/orderHistoryConstants";
import {
  EVENT_HAMBURGER_CLOSED,
  EVENT_HAMBURGER_LIST_ITEM_CLICKED,
  EVENT_LOGIN_CTA_CLICKED,
  EVENT_LOGOUT_CTA_CLICKED,
} from "../helpers/analyticsEvents";
import { clientPlatform } from "../config/apiEndpoints";
import Loader from "./Loader.vue";
import { defineAsyncComponent } from "vue";
import ShimmerProfileDrawerModal from "./ShimmerProfileDrawerModal.vue";
import LazyImage from "./LazyImage.vue";

export default {
  components: {
    GenericModal,
    Carousel,
    Slide,
    Pagination,
    Loader,
    ShimmerProfileDrawerModal: defineAsyncComponent(
      () => import("./ShimmerProfileDrawerModal.vue"),
    ),
    LazyImage,
    ShimmerProfileDrawerModal,
  },
  name: "ProfileDrawerModal",
  data() {
    return {
      clientPlatform,
      hamburgerMenuModal: {
        width: "100vw",
        height: "100vh",
        modalClass: "profile-Modal",
        overflow: "scroll",
      },
      LogoutModalDim: {
        width: "85vw",
        height: "auto",
        padding: "0px",
        paddingTop: "0px",
        paddingBottom: "0px",
      },
      links: [],
      groupMenuByGroupName: {},
      showLogoutModal: false,
    };
  },
  props: {
    logoutModalOpened: { required: false, default: () => {} },
  },

  mounted() {
    document.body.classList.add("body-stop-scroll-mobile");
  },

  methods: {
    closeModalA(type = "") {
      document.body.classList.remove("body-stop-scroll-mobile");
      EVENT_HAMBURGER_CLOSED();
      if (type == "clicked") {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
          false,
        );
      } else {
        setTimeout(() => this.$emit("close-profile-modal"), 2000);
      }
    },
    handleLogoutPopup() {
      this.logoutModalOpened(!this.showLogoutModal);
      this.showLogoutModal = !this.showLogoutModal;
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showLogoutModal = false;
      this.logoutModalOpened(false);
    },
    handleLogoutCTA() {
      EVENT_LOGOUT_CTA_CLICKED();
      this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {
        isLogout: true,
      });
    },
    handleLoginCTA() {
      this.closeModalA();
      EVENT_LOGIN_CTA_CLICKED({ sectionName: "hamburger" });
      Utility.sendToLoginScreen();
    },
    handleDrawerClick(e, item) {
      e.preventDefault();
      // this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, true);
      // if (item?.link_rewrite == "/my-profile" || item?.name =="My Profile") {
      //   this.$store.commit(keyMapsMutation.UPDATE_SHOW_PROFILE_MODAL, true);
      // } else
      if (item?.linkRewrite) {
        EVENT_HAMBURGER_LIST_ITEM_CLICKED({
          sectionPosition: Utility.getHamburgerItemIndex(
            item,
            this.menuGroupsData,
          ),
          category: item?.name,
        });
        if (item?.loginRequired && !LocalStorageFunc.isLoggedIn()) {
          Utility.sendToLoginScreen(item.linkRewrite);
        } else {
          if (item?.linkRewrite == "/order-history") {
            LocalStorageFunc.setOrderHistoryPage(OrderHistoryPages.MY_ORDERS);
          }
          Utility.redirectToLinkRewrite(item.linkRewrite);
        }
        this.closeModalA();
      }
    },
  },

  computed: {
    isLoggedIn() {
      return LocalStorageFunc.isLoggedIn();
    },
    mobileNo() {
      return LocalStorageFunc.getUserMobileNo();
    },
    getCouponText() {
      return this.$store.state.Offers.offersList.length
        ? `You've got ${
            this.$store.state.Offers.offersList.length > 1
              ? this.$store.state.Offers.offersList.length + " coupons"
              : this.$store.state.Offers.offersList.length + " coupon"
          }`
        : "";
    },
    getWalletText() {
      return this.$store.state.WalletInfo.WalletTotalBalance > 0
        ? `${this.$store.state.WalletInfo.WalletTotalBalance + " points"}`
        : "";
    },
    menuGroupsData() {
      this.links = this.$store.state.Profile.menuGroupsData
        ? this.$store.state.Profile.menuGroupsData
        : [];
      this.groupMenuByGroupName = Utility.groupArrayOfObjectBykey(
        this.links,
        "menuGroup",
      );
      return Utility.getArrayFromObject(this.groupMenuByGroupName);
    },
  },
};
</script>

<style scoped></style>
